import {
  SYSTEM_LIST_REQUEST,
  DASHBOARD_LIST_REQUEST,
  ACTIVATION_LIST_REQUEST,
  ALERT_LIST_REQUEST,
  SEARCH_LIST_REQUEST,
  RESET_SEARCH_LIST,
  GET_ENLM_FEEDBACK_REQUEST,
  ADD_ENLM_FEEDBACK_REQUEST,
  GET_GRID_PROFILE_TOKEN_REQUEST,
  GET_SYSTEM_SAVED_SEARCH_REQUEST,
  FILTER_LIST_REQUEST,
  GET_SERVICE_MANAGER_CASES_REQUEST
} from './constants';

export function getAllSystemList(payload) {
  return { type: SYSTEM_LIST_REQUEST, payload };
}
export function getAllDashboardList(payload) {
  return { type: DASHBOARD_LIST_REQUEST, payload };
}

export function getAllActivationList(payload) {
  return { type: ACTIVATION_LIST_REQUEST, payload };
}

export function getAllAlertList(payload) {
  return { type: ALERT_LIST_REQUEST, payload };
}

export function getSearchData(payload) {
  return { type: SEARCH_LIST_REQUEST, payload };
}

export function resetSearchData() {
  return { type: RESET_SEARCH_LIST };
}

export function getEnlmFeedback() {
  return { type: GET_ENLM_FEEDBACK_REQUEST };
}

export function addEnlmFeedback(payload) {
  return { type: ADD_ENLM_FEEDBACK_REQUEST, payload };
}

export function getGridProfileToken(payload) {
  return { type: GET_GRID_PROFILE_TOKEN_REQUEST, payload };
}

export function getSystemSavedSearch() {
  return { type: GET_SYSTEM_SAVED_SEARCH_REQUEST };
}

export function getFilteredList(payload) {
  return { type: FILTER_LIST_REQUEST, payload };
}

export function getServiceManagerCases() {
  return { type: GET_SERVICE_MANAGER_CASES_REQUEST };
}
